export const LoginSceneTranslation = {
  fi: {
    LoginScene: {
      forgotPassword: 'Unohditko salasanasi?',
      login: 'Kirjaudu',
      fillInformation: 'Täytä tiedot ja kirjaudu sisään',
    },
  },
};
